import { BranchParams } from 'react-native-branch';

import { CustomEventNames, logEvent } from 'state/amplitude';
import { EventTypes } from 'state/amplitude/types';
import { logger } from 'utils/logger';

// Known non-organic referrer hosts (Branch + Braze click-tracking). Braze CTD is configurable per account; add yours if different.
const NON_ORGANIC_REFERRER_HOSTS = [
  'app.link',
  'alternate.link',
  'ablinks.com', // common Braze click-tracking domain
  'braze.com',
];

const isNonOrganicReferrer = (referrer: string): boolean => {
  try {
    const host = new URL(referrer).hostname.toLowerCase();
    return NON_ORGANIC_REFERRER_HOSTS.some(h => host === h || host.endsWith('.' + h));
  } catch {
    return false;
  }
};

export const categorizeTraffic = (_params: BranchParams) => {
  const isBranchLink = window.location.search.includes('_branch_');
  // Non-organic link: Branch (_branch_ in URL), or Braze (lid= in URL – confirm with CRM), or referrer from known CTD (Branch/Braze).
  const isBrazeOrOtherNonOrganicLink =
    window.location.search.includes('lid=') ||
    (document.referrer ? isNonOrganicReferrer(document.referrer) : false);
  const isNonOrganicLink = isBranchLink || isBrazeOrOtherNonOrganicLink;
  // Destination: what page is loading?
  const destination = window.location.href ?? null;
  // Source: who sent us this traffic?
  const source = document.referrer ?? null;
  // If there is no known source, or the source is the same origin as the destination,
  // we judge the traffic as organic.
  let isOrganic = !source && !isNonOrganicLink;
  if (source) {
    // Same-origin navigation = organic; Branch/Braze (and other CTD) traffic is always non-organic.
    try {
      const destinationOrigin = new URL(destination).origin;
      const sourceOrigin = new URL(source).origin;
      isOrganic = destinationOrigin === sourceOrigin && !isNonOrganicLink;
    } catch {
      logger.error({ message: 'unexpected source or destination', source, destination });
      isOrganic = false;
    }
  }
  // TODO: verify the behavior of Braze universal email links like <a href="https://www.bk.com/menu" universal="true">
  // Expectation is a referrer of either burgerking.app.link/abc123 or possibly a click tracking domain like ablinks.com
  // https://www.braze.com/docs/user_guide/message_building_by_channel/email/universal_links/#universal-links-app-links-and-click-tracking
  logEvent(CustomEventNames.APP_OPEN, EventTypes.Other, { source, destination, isOrganic });
};
